import styled from "styled-components";

export const DraggableContainer = styled.div`
  position: relative;
  z-index: 0;
`;

export const DraggablePlaceholder = styled.div<{ height: number }>`
  border: 2px dashed #b9b9b9;
  position: absolute;
  height: ${props => props.height}rem;
  top: 0;
  width: calc(100% - 1rem);
  z-index: -1;
  border-radius: 0.5rem;
`;

export const DraggableItem = styled.div<{ isDragging: boolean }>`
  position: ${props => (props.isDragging ? "relative" : "")};
  z-index: ${props => (props.isDragging ? 10 : 0)};
`;
